import http from '~/http/new';

export default ({
  state: {
    data: [],
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_DATA(state, data) { state.data = data; },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ commit }, id) {
      const response = await http.get(`v1/p2p/profile/${id}/info`, {
        params: {
          id,
        },
      });
      const { profile } = response.data;
      commit('SET_DATA', profile);
    },
  },

  namespaced: true,
});
